import React from "react"
import {
  LineChart as RechartsLineChart,
  Line,
  Tooltip,
  ResponsiveContainer,
} from "recharts"

const colorLineA = "#4F8FD9"
const colorLineB = "#FE715C"
const colorLineC = "#5BDE90"

const formatNumberWithThousandSeparator = (
  number: number,
  thousandSeparator: string
) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)

const CustomTooltip = props => {
  const { active, payload, thing } = props
  if (!active) {
    return null
  }

  const date = new Date(payload[0].payload.date)
  const month = date.toLocaleDateString("en-GB", {
    month: "short",
  })

  return (
    <div className="chart-custom-tooltip">
      <div className="font-weight-bold small chart-custom-tooltip-label">
        {month} {date.getDate()}
      </div>
      <div className="chart-custom-tooltip-value">
        {payload.map((item, idx) => (
          <span
            key={idx}
            className="d-block"
            style={{
              color:
                idx === 0 ? colorLineA : idx === 1 ? colorLineB : colorLineC,
            }}
          >
            {item.name.substring(0, 15)}:{" "}
            {formatNumberWithThousandSeparator(item.value, ",")} {thing}
          </span>
        ))}
      </div>
    </div>
  )
}

interface Props {
  height: number
  data: LineChartData
  thing?: string
}

export type LineChartData = {
  date: Date
  legendA: string
  legendB?: string
  legendC?: string
  valueA: number
  valueB?: number
  valueC?: number
}[]

export const LineChart: React.FC<Props> = ({ data, height, thing = "" }) => {
  return (
    <div style={{ width: "100%", height }}>
      <ResponsiveContainer>
        <RechartsLineChart data={data}>
          <Tooltip
            cursor={false}
            content={p => <CustomTooltip {...p} thing={thing} />}
          />
          <Line
            type="monotone"
            dataKey="valueA"
            stroke={colorLineA}
            xAxisId={"data"}
            strokeWidth={2}
            name={data[0].legendA}
            dot={false}
          />

          {data[0] && data[0].valueB ? (
            <Line
              type="monotone"
              dataKey="valueB"
              stroke={colorLineB}
              xAxisId={"data"}
              strokeWidth={2}
              name={data[0].legendB}
              dot={false}
            />
          ) : null}

          {data[0] && data[0].valueC ? (
            <Line
              type="monotone"
              dataKey="valueC"
              stroke={colorLineC}
              xAxisId={"data"}
              strokeWidth={2}
              name={data[0].legendC}
              dot={false}
            />
          ) : null}
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>
  )
}
